export default __webpack_public_path__ + "static/media/Icons-33.c748c4fa.png";